import React from "react";

export default function HiddenIcon({ fill }) {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   version="1.1"
    //   width="15px"
    //   height="15px"
    //   viewBox="0 0 50 50"
    // >
    //   <g>
    //     <path
    //       fill="#2b9ef8"
    //       d="M 47.5,23.5 C 47.5,25.1667 47.5,26.8333 47.5,28.5C 46.1779,28.67 45.0113,28.3366 44,27.5C 42.1196,22.625 39.1196,18.625 35,15.5C 33.647,16.6853 32.4803,18.0186 31.5,19.5C 35.522,28.4526 32.8554,34.1193 23.5,36.5C 20.8292,35.6433 18.1626,35.1433 15.5,35C 12.8333,37.6667 10.1667,40.3333 7.5,43C 6.20677,43.49 4.87344,43.6567 3.5,43.5C 3.5,42.5 3.5,41.5 3.5,40.5C 5.54408,39.9688 7.21075,38.8022 8.5,37C 8.27155,36.6012 7.93822,36.4346 7.5,36.5C 17.9646,25.5349 28.6312,14.7016 39.5,4C 40.7932,3.50999 42.1266,3.34332 43.5,3.5C 43.6567,4.87344 43.49,6.20677 43,7.5C 41.3149,9.01748 39.8149,10.6841 38.5,12.5C 42.2261,15.6465 45.2261,19.3131 47.5,23.5 Z"
    //     />
    //   </g>
    //   <g>
    //     <path
    //       fill="#2ca2f8"
    //       d="M -0.5,28.5 C -0.5,26.8333 -0.5,25.1667 -0.5,23.5C 6.53247,10.4859 17.1991,5.98587 31.5,10C 30.8333,10.6667 30.1667,11.3333 29.5,12C 16.8018,10.9213 7.96851,16.088 3,27.5C 1.98873,28.3366 0.822066,28.67 -0.5,28.5 Z"
    //     />
    //   </g>
    //   <g>
    //     <path
    //       fill="#2da0f8"
    //       d="M 18.5,16.5 C 20.5273,16.3379 22.5273,16.5045 24.5,17C 21,20.5 17.5,24 14,27.5C 13.3333,25.8333 13.3333,24.1667 14,22.5C 15.332,20.34 16.832,18.34 18.5,16.5 Z"
    //     />
    //   </g>
    //   <g>
    //     <path
    //       fill="#31bffa"
    //       d="M 7.5,36.5 C 7.93822,36.4346 8.27155,36.6012 8.5,37C 7.21075,38.8022 5.54408,39.9688 3.5,40.5C 4.5,38.8333 5.83333,37.5 7.5,36.5 Z"
    //     />
    //   </g>
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={19}
      viewBox="0 0 640 512"
    >
      <path
        fill={fill}
        d="M150.7 92.77C195 58.27 251.8 32 320 32C400.8 32 465.5 68.84 512.6 112.6C559.4 156 590.7 207.1 605.5 243.7C608.8 251.6 608.8 260.4 605.5 268.3C592.1 300.6 565.2 346.1 525.6 386.7L630.8 469.1C641.2 477.3 643.1 492.4 634.9 502.8C626.7 513.2 611.6 515.1 601.2 506.9L9.196 42.89C-1.236 34.71-3.065 19.63 5.112 9.196C13.29-1.236 28.37-3.065 38.81 5.112L150.7 92.77zM189.8 123.5L235.8 159.5C258.3 139.9 287.8 128 320 128C390.7 128 448 185.3 448 256C448 277.2 442.9 297.1 433.8 314.7L487.6 356.9C521.1 322.8 545.9 283.1 558.6 256C544.1 225.1 518.4 183.5 479.9 147.7C438.8 109.6 385.2 79.1 320 79.1C269.5 79.1 225.1 97.73 189.8 123.5L189.8 123.5zM394.9 284.2C398.2 275.4 400 265.9 400 255.1C400 211.8 364.2 175.1 320 175.1C319.3 175.1 318.7 176 317.1 176C319.3 181.1 320 186.5 320 191.1C320 202.2 317.6 211.8 313.4 220.3L394.9 284.2zM404.3 414.5L446.2 447.5C409.9 467.1 367.8 480 320 480C239.2 480 174.5 443.2 127.4 399.4C80.62 355.1 49.34 304 34.46 268.3C31.18 260.4 31.18 251.6 34.46 243.7C44 220.8 60.29 191.2 83.09 161.5L120.8 191.2C102.1 214.5 89.76 237.6 81.45 255.1C95.02 286 121.6 328.5 160.1 364.3C201.2 402.4 254.8 432 320 432C350.7 432 378.8 425.4 404.3 414.5H404.3zM192 255.1C192 253.1 192.1 250.3 192.3 247.5L248.4 291.7C258.9 312.8 278.5 328.6 302 333.1L358.2 378.2C346.1 381.1 333.3 384 319.1 384C249.3 384 191.1 326.7 191.1 255.1H192z"
      />
    </svg>
  );
}
